<h1 class="text-center flex center">Workspace Disabled</h1>
<div mat-dialog-content class="disabled-text">
    Please note that this workspace has been disabled, should you wish to gain access to this workspace please contact <b>Biz@moya.app</b> for further assistance.
</div>
<div class="modal-footer flex end">

	<button
    matSuffix
    [mat-dialog-close]
		mat-button
		type="button"
		class="blueButton"
        (click)="tools.copyToClipBoard('Biz@moya.app')"
		>Copy Email</button
	>
</div>